module.exports = __webpack_public_path__ + "TheStarfishface.jpg?3977c9969a86ffba6defeaf6054c4cf5";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/TheStarfishface.jpg
// module id = 555
// module chunks = 0